import { mapGetters } from 'vuex'
import * as getters from '@/store/getters/types'

const BRANCH_NAMES = {
  EV_GROUP: 'evgroup',
  TESTKBP: 'testkbp',
}

export default {
  computed: {
    ...mapGetters({
      build: getters.BUILD,
    }),
    branchName () {
      if (!this.build) return ''

      const match = this.build.match(/uchi-next\s+(\S+)/)
      return match ? match[1] : ''
    },

    isKaEvGroup () {
      return this.branchName === BRANCH_NAMES.EV_GROUP
    },

    isTestkbp () {
      return this.branchName === BRANCH_NAMES.TESTKBP
    },
  },
}
